<template>
<v-card class="theme-bg-card-interface">
  <div>

    <sequential-entrance fromBottom delay="500" >

<v-container>
  <v-row no-gutters>


<v-col>   
    <template v-for="(item, index) in items">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-for="(item, index) in items2">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
</v-col>

<v-col>   
        <template v-for="(item, index) in items3">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
</v-col>

   <v-col>      

  <v-card class="video-card-interface" style="padding: 0px; align: width: 100%">
  <youtube :video-id="videoId" width="800" height="450" :player-vars="playerVars" @playing="playing"></youtube>

	</v-card>

</v-col>

  </v-row>
</v-container>

    </sequential-entrance>
  </div>
</v-card>
</template>

<script>
export default {
  name: "command assistant",
  components: {},
  data() {
    return {
      media: null,
      videoId: 'sksqe8X2iVM',
      playerVars: {
        autoplay: 1
      },
      items: [
        {
          title: "Wishing you the most amazing and prodcutive New Years ever, with lots of love and happiness from the small team at Machinist.",
          explanation: "Play Demo",
        },
      ],
 components: {

  },
  methods: {
    playing() {
      console.log('We are watching!!!')
    }
  }
    };
  },
};
</script>

<style scoped>


.video-card-interface {
 background: rgba(48, 64, 87, 0.1);
 outline-color: rgba(90, 128, 191, 0.3);

  padding: 0px;

}



.theme-bg-card-interface {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(9, 1, 24, 0.7);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.60);
  padding: 50px;
  width: 1600px;
  height: 600px;

}

.space {
  height: 100px;
}
.space1 {
  height: 30px;
}
.mrgn-top {
  text-align: center;
}
.center-aligned {
  text-align: center;
  color: rgb(58, 57, 57);
}
h3 {
  color: #888;
}
</style>
